<template>
  <DxSplitter v-bind="$attrs" orientation="horizontal">
    <slot/>
  </DxSplitter>
</template>

<script setup>
  import { DxSplitter } from 'devextreme-vue/splitter';
  defineOptions({ inheritAttrs: true })
</script>

<style scoped lang="scss">
  :deep(.dx-resize-handle-icon),
  :deep(.dx-resize-handle-collapse-next-pane),
  :deep(.dx-resize-handle-collapse-prev-pane) {
    display: none;
  }

  // Creates a visual thin line in default color
  :deep(.dx-resize-handle)::before {
    content: '';
    position: absolute;
    inset: 0;
    margin: auto;
    width: 1px;
    background: var(--dx-splitter-line, #ccc);
  }

  // Makes the clickable area wider
  :deep(.dx-resize-handle) {
    width: 5px !important;
    background: transparent !important;
    position: relative;
    cursor: col-resize;
  }
</style>
